import { EntityTypes } from './enums/entityTypes';
import { QuestionTypes } from './enums/questionTypes';

export interface Assessment {
  assessmentId: string;
  entityType: EntityTypes.assessment;
  sections: AssessmentSection[];
  created: number;
  lastUpdated: number;
}

export interface AssessmentSection {
  section: string;
  slug: string;
  subSections: AssessmentSubSectionsCount;
  duration: number;
  overview: string;
  questions: AssessmentQuestion[];
}

export interface AssessmentSubSectionsCount {
  [key: string]: number;
}

export interface AssessmentQuestion {
  id: number;
  question: string;
  subSection: string;
  type: QuestionTypes;
  choices?: string[];
  format?: string;
  formatBreakout?: string[];
  documentation: boolean;
  documentation_desc?: string;
  count?: number;
  sequence?: number;
  followUpActivation?: string;
  followUpQuestions?: AssessmentQuestion[];
  labelAnswerId?: number;
  unavailableText?: string;
}
